import React from 'react'

export const ProfessionalStatus = ({ status }) => {
  switch (status) {
    case 'online':
      return <span style={{ color: '#99ff43' }} className={'fas fa-circle'} />

    case 'offline':
      return <span style={{ color: '#FF3900' }} className={'fas fa-circle'} />

    default:
      return <span style={{ color: '#4f4c4f' }} className={'fas fa-circle'} />
  }
}
